import CenteredHeaders from 'components/common/CenteredHeaders';
import Item from 'components/common/Item';
import React from 'react';
import { ChatState } from 'store/chat/types';
import MissingUtbedring from './MissingUtbedring';
import styles from './styles.scss';

interface Props {
  tilstandsrapportId: string;
  sjekkpunkter: string[];
  header: string;
  subtitle?: string;
  missingText?: string;
  className?: string;
  chat?: ChatState;
}

const ListItems = ({
  tilstandsrapportId,
  header,
  subtitle,
  sjekkpunkter,
  missingText,
  className,
  chat,
}: Props): JSX.Element => {

  return (
    <section className={className && className}>
      <div className={styles.headerBox}>
        <CenteredHeaders header={header} subtitle={subtitle} />
      </div>
      {sjekkpunkter.length > 0 ? (
        <ul className={styles.improvements}>
          {sjekkpunkter.map((id: string) => (
            <Item chat={chat} key={id} id={id} tilstandsrapportId={tilstandsrapportId} />
          ))}
        </ul>
      ) : (
        missingText && <MissingUtbedring missingText={missingText} />
      )}
    </section>
  );
};

export default ListItems;
